import { render, staticRenderFns } from "./form-text-noinput.vue?vue&type=template&id=f7bccd90"
import script from "./form-text-noinput.vue?vue&type=script&lang=js"
export * from "./form-text-noinput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports